import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Container, CircularProgress, TextField, Table, Modal, TableBody, TableCell, Box, Typography, Toolbar, AppBar, TableContainer, TableHead, TableRow, Paper, InputAdornment } from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import Tooltip from '@mui/material/Tooltip';
import base64 from 'base64-js';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const City = () => {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const navigate = useNavigate();
  const [city, setCity] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  const [selectedCity, setSelectedCity] = useState({ cityId: null, cityName: '' });
  const [authorization, setAuthorization] = useState([]);
  const [canDelete, setCanDelete] = useState(true); // Default to true, assuming user can delete
  const [canEdit, setCanEdit] = useState(true);
  const [canAdd, setCanAdd] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const handleAddCity = () => {
    navigate('/addcity');
  };

  const handleEdit = (cityId) => {
    navigate(`/editcity/${cityId}`);
  };

  const handleDelete = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/City/Id?CityId=${selectedCity.cityId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
        }
      );
      if (response.ok) {
        // Handle success, e.g., refresh the data
        setShowModal(false);
        setLoadingBarProgress(100);
        fetchCityData();
        setSnackbarMessage('City deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success");
      } else {
        setLoadingBarProgress(0);
        console.error('Delete failed');
        // alert('Failed to delete city');
        setSnackbarMessage('Failed to delete city');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const { encodedFormId } = useParams();

  const decodeFormId = (encodedFormId) => {
    const bytes = base64.toByteArray(encodedFormId);
    return new TextDecoder().decode(bytes);
  };
  const formId = decodeFormId(encodedFormId);
  console.log(formId)

  const fetchCityData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/City/GetCity`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const data = await response.json();
        if (Array.isArray(data)) {
          setCity(data);
        } else {
          // If data is not an array, handle it accordingly.
          console.error('City data is not an array:', data);
          // For example, you could set a default value or handle it in some other way.
          setCity([]);
        }
        setLoadingBarProgress(100);
      } else {
        setLoadingBarProgress(0);
        console.error('Failed to fetch city data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };


  useEffect(() => {
    fetchCityData();
    Authorizer();
  }, []);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      //setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          formId
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setAuthorization(responseData);
        // Check permissions for Delete and Edit
        const authorizationData = responseData[0];
        setCanDelete(authorizationData.uDelete === 1);
        setCanEdit(authorizationData.uModify === 1);
        setCanAdd(authorizationData.uWrite === 1);
        //setLoadingBarProgress(100);
      } else {
        console.error('Country name incorrect');
        // alert('Invalid country name');
        setSnackbarMessage('Invalid country name');
        setOpenSnackbar(true);
        setSnackbarSeverity("warning");
        //setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleShow = (cityId, cityName) => {
    setSelectedCity({ cityId, cityName });
    setShowModal(true);
  };

  const handleClose = () => {
    // setCity(null);
    setShowModal(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };

  const filteredData = city.filter((city) =>
    city.countryName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    city.stateName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    city.cityName.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  return (
    <Container mt={5}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: "bold" }}>
            City
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem', marginLeft: '5px' }}>
          <TextField
            variant="outlined"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
              style: { padding: '0px 8px' },
            }}
            sx={{
              width: 300,
              backgroundColor: '#f9f9f9',
            }}
          />
          <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow><span>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddCity}
              style={{
                width: "160px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}
              disabled={!canAdd}
            >
              ADD NEW CITY
            </Button></span></Tooltip>
        </div>

        <TableContainer component={Paper} mt={3}>
          <Table
            sx={{
              minWidth: 650,
              border: '1px solid #ccc',
              '& .MuiTableCell-root': {
                borderRight: '1px solid #ccc', // vertical line
                fontSize: '1rem', // increased font size
              },
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>Country Name</TableCell>
                <TableCell>State Name</TableCell>
                <TableCell>City Name</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loadingBarProgress > 0 && loadingBarProgress < 100 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : paginatedData.length > 0 ? (
                paginatedData.map((city) => (

                  <TableRow key={city.cityId}>
                    <TableCell>{city.countryName}</TableCell>
                    <TableCell>{city.stateName}</TableCell>
                    <TableCell>{city.cityName}</TableCell>
                    <TableCell align="center">
                      <Tooltip title={canEdit ? '' : 'You are not authorized to edit'} arrow>
                        <span>
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={() => handleEdit(city.cityId)}
                            disabled={!canEdit}
                            startIcon={<EditIcon />}
                            style={{ marginRight: '6px' }}
                          >
                            Edit
                          </Button>
                        </span>
                      </Tooltip>
                      <Tooltip title={canDelete ? '' : 'You are not authorized to delete'} arrow>
                        <span>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() => handleShow(city.cityId, city.cityName)}
                            disabled={!canDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </Button>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No Cities Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                overflow: 'hidden',
              }}
            >
              {/* Header */}
              <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
                <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                  Delete Confirmation ⚠️
                </Typography>
              </Box>

              {/* Content */}
              <Box sx={{ padding: '20px' }}>
                <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                  Are you sure you want to delete <strong>{selectedCity?.cityName}</strong>?
                </Typography>

                {/* Buttons */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDelete(handleDelete)}
                  >
                    Yes, Delete
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </TableContainer>

        {filteredData.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{ width: 150 }}
              SelectProps={{
                native: true,
              }}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>

            <Box>
              <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 1}
                sx={{ mr: 1 }}
              >
                Prev
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              >
                Next
              </Button>
            </Box>
          </Box>
        )}

      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default City;
// {selectedCity?.cityName}
